import { entranceReducer } from './entranceReducer';

export default entranceReducer;
